import React, {
  FC,
  RefObject,
} from 'react';
import {
  MultiRootHookReturns,
} from '@ckeditor/ckeditor5-react';
import HPIAIToolbarItem from 'views/EMR/components/TextAreaToolbar/HPIAI';
import DictationToolbarItem from 'views/EMR/components/TextAreaToolbar/Dictation';
import FieldToolbarItem from 'views/EMR/components/TextAreaToolbar/Field';
import SameToolbarItem from 'views/EMR/components/TextAreaToolbar/Same';
import TemplateToolbarItem from 'views/EMR/components/TextAreaToolbar/Template';

const actions = ['salt', 'hpi-ai', 'template', 'dictation', 'field'] as const;
export type ToolbarActionParams = {
  controls?: string[];
};
export type ToolbarAction = typeof actions[number] | {
  name: typeof actions[number];
  params: ToolbarActionParams;
};

export type ToolbarItemProps = Pick<MultiRootHookReturns, 'editor'> & {
  setData: (content: string) => void;
  id: string;
  contentEditorRef: RefObject<HTMLDivElement>;
} & ToolbarActionParams;

type Props = ToolbarItemProps & {
  items: ToolbarAction[];
};

const actionComponents: Record<typeof actions[number], FC<ToolbarItemProps>> = {
  salt: SameToolbarItem,
  'hpi-ai': HPIAIToolbarItem,
  template: TemplateToolbarItem,
  dictation: DictationToolbarItem,
  field: FieldToolbarItem,
};

export default function TextAreaToolbar({
  items,
  ...props
}: Props) {
  return (
    <div className="w-fit flex items-center gap-px">
      {items.map((action) => {
        const isObject = typeof action === 'object';
        const actionName = isObject ? action?.name : action;
        const Component = actionComponents[actionName];
        return (
          <Component
            key={actionName}
            {...props}
            {...(isObject ? action?.params : {})}
          />
        );
      })}
    </div>
  );
}
